import { useState, useCallback } from 'react';
import { recoveryService, RecoveryAction } from '../services/recoveryService';

interface ErrorRecoveryState {
  isModalOpen: boolean;
  currentError: any;
  recoveryActions: RecoveryAction[];
}

export const useErrorRecovery = () => {
  const [state, setState] = useState<ErrorRecoveryState>({
    isModalOpen: false,
    currentError: null,
    recoveryActions: []
  });

  const showRecoveryModal = useCallback(async (error: any) => {
    const actions = recoveryService.getUserRecoveryActions(error);
    
    setState({
      isModalOpen: true,
      currentError: error,
      recoveryActions: actions
    });

    // Auto-attempt recovery first
    const recovered = await recoveryService.attemptAutoRecovery(error);
    if (recovered) {
      setState(prev => ({ ...prev, isModalOpen: false }));
      return;
    }

    // Notify super admin
    await recoveryService.notifySuperAdmin(error, {
      location: window.location.pathname,
      timestamp: Date.now(),
      userAgent: navigator.userAgent
    });
  }, []);

  const closeModal = useCallback(() => {
    setState({
      isModalOpen: false,
      currentError: null,
      recoveryActions: []
    });
  }, []);

  return {
    ...state,
    showRecoveryModal,
    closeModal
  };
};
